import { useCallback, useMemo } from 'react';
import { useTrialsListQuery } from '@/queries/trial-programs';
import { OrganType } from '@/api/apis/case';

export const useTrialProgramsList = () => {
  const { data: trialProgramsData } = useTrialsListQuery();

  const trialProgramsList = useMemo(() => {
    return trialProgramsData?.items?.map(({ id, name, organ }) => ({ name, value: id, organ })) || [];
  }, [trialProgramsData]);

  const getTrialProgramByOrgan = useCallback(
    (organ: OrganType) => {
      return trialProgramsData?.items?.find((p) => p.organ === organ) || null;
    },
    [trialProgramsData],
  );

  return {
    trialProgramsList,
    getTrialProgramByOrgan,
  };
};
